<template>
  <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
    <el-form-item label="姓名" prop="name">
      <el-input v-model="ruleForm.name"></el-input>
    </el-form-item>
    <el-form-item label="身份证号" prop="identNo">
      <el-input v-model="ruleForm.identNo"></el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="submitForm('ruleForm')">立即去认证</el-button>
      <el-button @click="resetForm('ruleForm')">重置</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { userinfoApi } from '../../api/getData'
import { getPersonVerifyUrlApi } from '../../api/getData'

export default {
  data() {
    return {
      ruleForm: {
        name: '',
        identNo: '',
        mobile: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 1, max: 10, message: '长度在 1 到 10 个字符', trigger: 'blur' }
        ],
        identNo: [
          { required: true, message: '请输入身份证号码', trigger: 'blur' },
          { min: 1, max: 20, message: '长度在 18 到 20 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    getToken() {
      return this.$store.state.token
    }
  },
  methods: {
    //获取当前用户信息
    async getUserInfo() {
      try {
        const result = await userinfoApi(this.getToken)
        if (result.data.code === 0) {
          this.ruleForm.mobile = result.data.data.mobile
        }
      } catch (error) {
        console.log(error)
      }
    },
    submitForm(ruleForm) {
      this.$refs[ruleForm].validate(valid => {
        if (valid) {
          var mobile = this.ruleForm.mobile
          //调用认证接口获取认证url
          getPersonVerifyUrlApi(mobile, this.ruleForm.name, this.ruleForm.identNo).then(res => {
            if (res.data.code === 0) {
              res = res.data
              let url = res.data.url //base64加密的url
              let Base64 = require('js-base64').Base64
              let decodeUrl = Base64.decode(url) //解密的url
              //跳转至fdd认证页面url
              window.location.href = decodeUrl
            }
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    resetForm(formName) {
      this.$refs[formName].resetFields()
    }
  },
  mounted() {
    this.getUserInfo()
    if (this.getToken) {
      console.info(this.getToken)
      this.getUserInfo()
    }
  }
}
</script>

<style lang="scss" scoped>
.demo-ruleForm {
  width: 500px;
}
</style>
